
    <mat-form-field class="lookupComp" hideRequiredMarker style="text-align: left;width:100%">
        <mat-label>{{title}}</mat-label>
        <input matInput
            style="text-align: left;"
            (click)="clickVal()"
            [ngClass]="((_disabled) ? 'lookupInput disabledLookup' : 'lookupInput') + ((linkHref !== undefined) ? ' isALink' : '') "
            [value]="(_value | getText:idPropertyName:displayPropertyName:values) || altDisplay || ''"
            readonly
            [required]="required"
            />
            <span [ngClass]="(_disabled) ? 'lookupMagGlass disabledMag layout-align-end-start' : 'lookupMagGlass layout-align-end-start'" (click)="clickMagnifyingGlass()"><i class="fa fa-search"></i></span>
    </mat-form-field>

